import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { LoginActions } from '../../Services/_actions/LoginAction/LoginAction.ts';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router";
import { isValidEmail, isValidPhoneNumber } from '../../utils/helper.jsx';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../Shared/Loading/index.tsx';
const ModalForms = React.lazy(() => import('../Shared/Modals/index.js'));

interface GuestLoginModalProps {
    open: boolean;
    onClose: (data, type) => void;
}

const GuestLoginModal: React.FC<GuestLoginModalProps> = ({
    open,
    onClose,
}) => {
    const action = LoginActions();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [guestLoginData, setGuestLoginData] = React.useState({
        first_name: '',
        username: '',
        email: '',
        user_code: 99,
        mobile: null,
    });
    const [guestLoginError, setGuestLoginError] = React.useState({});

    const { showSnackBar } = useSnackBar();

    const handleSubmitGuestLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const errors = {};
        if (!guestLoginData.first_name) errors.first_name = 'Name is required';
        if (!guestLoginData.email) errors.email = 'Email is required';
        else if (!isValidEmail(guestLoginData.email)) errors.email = 'Invalid email format';
        if (!guestLoginData.mobile && !isValidPhoneNumber(guestLoginData?.mobile)) errors.mobile = 'Mobile number is required';
        setGuestLoginError(errors);
        if (Object.keys(errors).length > 0) {
            showSnackBar('Please fix the errors in the form.', 'error');
            setIsSubmitting(false);
            return;
        }

        try {
            const response = await action.guestLogin(guestLoginData);
            if (response?.status === 200) {
                // localStorage.setItem('machadalo-credentials', JSON.stringify(response?.data));
                // const userInfo = await action.userInformation(response.data.user_id);
                // if (userInfo?.status === 200) {
                //   localStorage.setItem('userInfo', JSON.stringify(userInfo?.data ?? userInfo));
                // }
                onClose(false);
            } else {
                showSnackBar(response.data.message ?? 'Guest login failed. Please try again.', "error");
            }
        } catch (error) {
            showSnackBar('Guest login failed. Please try again.', "error");
        } finally {
            setIsSubmitting(false);
        }
    };


    return (

        <>
            <ModalForms
                show={open}
                handleClose={onClose}
                modalHeader={"Login with Guest Account"}
                modalBody={
                    <>
                        <TextField
                            id="name-guestLogin"
                            label={
                                <Typography component="span">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </Typography>
                            }
                            placeholder='Enter your name'
                            type="text"
                            name="name"
                            size='small'
                            autoComplete="name"
                            value={guestLoginData?.first_name ?? ""}
                            onChange={(e) => setGuestLoginData({ ...guestLoginData, first_name: e.target.value })}
                            fullWidth
                            error={guestLoginError?.first_name}
                            helperText={guestLoginError?.first_name ?? ''}
                        />
                        <TextField
                            label={
                                <Typography component="span">
                                    Email <span style={{ color: 'red' }}>*</span>
                                </Typography>
                            }
                            id="email-guestLogin"
                            placeholder='Enter your email address'
                            type="email"
                            name="email"
                            size='small'
                            autoComplete="email"
                            value={guestLoginData?.email ?? ""}
                            onChange={(e) => setGuestLoginData({ ...guestLoginData, email: e.target.value, username: e.target.value })}
                            fullWidth
                            sx={{ marginTop: 2 }}
                            error={guestLoginError.email}
                            helperText={guestLoginError.email ?? ''}
                        />
                        <TextField
                            fullWidth
                            label={
                                <Typography component="span">
                                    Phone Number <span style={{ color: 'red' }}>*</span>
                                </Typography>
                            }
                            placeholder="Enter Mobile Number"
                            variant="outlined"
                            size="small"
                            value={guestLoginData?.mobile ?? ''}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                let mobileError = "";
                                if (/[^0-9]/.test(value)) {
                                    mobileError = "Characters are not allowed";
                                }
                                // setErrors(mobileError);
                                if (!mobileError) {
                                    setGuestLoginData({ ...guestLoginData, mobile: value });
                                    // setErrors("");
                                }
                            }}
                            error={guestLoginError.mobile}
                            helperText={guestLoginError.mobile ?? ''}
                            inputProps={{
                                maxLength: 13,
                                inputMode: "numeric",
                                pattern: "[0-9]*"
                            }}
                            sx={{ marginTop: 2 }}
                        />
                    </>
                }
                size="sm"
                modalFooter={
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                        <Button variant="outlined" size='small' onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                        <LoadingButton
                            variant="contained"
                            size='small'
                            buttonName="Continue"
                            isLoading={isSubmitting}
                            onClickButton={handleSubmitGuestLogin}
                        />
                    </Box>
                }
            />
        </>
    );
};
export default GuestLoginModal;